// extracted by mini-css-extract-plugin
export default {"container":"TimeInfo_container__sfTrG","label":"TimeInfo_label__MRPjF","value":"TimeInfo_value__h0GIf","clickable":"TimeInfo_clickable__U4M2o"};